@import '~style-sheet-helpers/core.less';
@import '../component.module.less';

.name-input {
  grid-column: 2 / span 6;
  grid-row: 1;
  position: relative;
}

.name-label {
  grid-row: 1;
}

.paste-address {
  grid-row: 1;
}

.paste-input-wrapper {
  grid-row: 2;
}

.paste-address-input {
  border: 1px solid @border-color;
  border-radius: 5px;
  align-items: center;
  padding-right: 0;
  height: 115px;
  font-size: 14px;
}

.input-row {
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 8px;
}
